import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import AddMasterTournament from "./components/addMasterTournament";
import Common from "../../../helper/common";
import { Button } from "../../../components/ui/button";
import AdvanceTable from "../../../components/advanceTable";
import { useLocation, useNavigate } from "react-router-dom";
import { ViewDateTimeFormat } from "../../../constants/appConstant";
import { useQueryParams } from "../../../contexts/queryParamsContext";

const MasterTournaments = () => {
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);
  const navigate = useNavigate();
  const { params, setParams, resetParams } = useQueryParams();

  useEffect(() => {
    getData(1);
  }, []);

  useEffect(() => {
    if (!open) {
      setRefId();
    }
  }, [open]);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    const response = await Common.ApiService.getInstance().request(
      "GetMasterTournaments",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        recordsToDisplay,
      },
      "Post"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          startDateTime: `${Common.moment(item.startDateTime).format(
            ViewDateTimeFormat
          )}`,
          endDateTime: `${Common.moment(item.endDateTime).format(
            ViewDateTimeFormat
          )}`,
          tournaments: rendertournamentsButton(item.id),
        })),
      };

      setData(obj);
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const rendertournamentsButton = (id) => {
    return (
      <div>
        <button
          style={{
            backgroundColor: "#2b2b8a",
            color: "white",
            padding: "6px 14px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
          onClick={() => {
            setParams({
              ...params,
              masterTournamentId: id,
            });
             //navigate(`/app/tournaments`);
            navigate(`/app/tournaments?masterTournamentId=${id}`);
          }}
        >
          Tournaments
        </button>
      </div>
    );
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Master Tournament?",
      "Delete Master Tournament"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteMasterTournaments?id=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const actions = [
    {
      type: "edit",
      // onClick: (val) => {
      //   setParams({ ...params, masterTournamentId: val.id });
      //   navigate(`/app/tournaments`);
      // },
          onClick: (val) => {
        setParams({ ...params, masterTournamentId: val.id });
              _onEdit(val.id)
          },
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  let columns = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Master Tournament Name",
      type: "text",
      isVisible: true,
      key: "name",
    },
    { title: "Icon", type: "image", isVisible: true, key: "icon" },
    { title: "Sport", type: "text", isVisible: true, key: "sportName" },
    {
      title: "Organizer Name",
      type: "text",
      isVisible: true,
      key: "organizerName",
    },
    {
      title: "Organizer Phone",
      type: "text",
      isVisible: true,
      key: "organizerPhoneNo",
    },
    {
      title: "Start Date",
      type: "text",
      isVisible: true,
      key: "startDateTime",
    },
    { title: "End Date", type: "text", isVisible: true, key: "endDateTime" },
    { title: "Tournaments", type: "html", isVisible: true, key: "tournaments" },
  ];

  const _addBtn = () => (
    <div className="flex gap-4 items-center">
      <Button
       onClick={() => 
        {
          resetParams();
          navigate("/app/tournaments")}
        }
       >
        <span className="text-xl mr-1">
          <Icon icon="material-symbols:list-rounded" />
        </span>
        All Categories
      </Button>

      <AddMasterTournament
        id={refId}
        onClose={() => getData()}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Tournaments"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={_addBtn}
          showPagination
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};

export default MasterTournaments;
